import { queryOptions } from '@tanstack/react-query'

import { listCompanies } from '@/services/fintalk/services/fintalk-backoffice/companies/list'

import { QUERY_KEYS } from '../keys'

export const companiesQueryOptions = (userId: string) => {
  return queryOptions({
    queryKey: QUERY_KEYS.companiesList(userId),
    queryFn: () => listCompanies(),
  })
}
